import { tableStore } from '../../stores';

export const usePifPanel = () => {
  // PSTUDIO-4000: read the EFFECTIVE list so a duplicate node number reaches
  // the popover (count + rows) straight off `rows`, without waiting for a
  // validateAndSync round-trip that some entrances never trigger.
  const { dataForCompiling, effectivePifErrors: pifErrors } = tableStore;

  // The two payloads below are for ONE thing: the "Download Agent Compiler
  // Data" action. They used to be serialized here, on every render of a popover
  // that is always mounted — `JSON.stringify(rows, null, 2)` measured ~46ms at
  // 5,000 rows, and reading `rows` inside an `observer` subscribes it to every
  // observable field of every row, so a drag-reorder paid for it too. That is
  // the very dependency on row `order` the store-side work in this ticket
  // removed, re-created one layer up.
  //
  // Returned as thunks instead: nothing is read until the download handler runs,
  // and the handler runs outside any reactive context, so no subscription is
  // registered at all.
  const getDiagnostics = () =>
    JSON.stringify(tableStore.originalPifCompilerDiagnostics, null, 2);
  const getRows = () => JSON.stringify(tableStore.rows, null, 2);

  return {
    getDiagnostics,
    dataForCompiling,
    pifErrors,
    getRows,
  };
};
